import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StandardModal from 'components/consumer/StandardModal';
import CtaLink from 'components/essentials/Cta/CtaLink';
import useScreen from 'hooks/useScreen';
import DesignServicesIcon from '../icons/DesignServicesIcon';
import KeySellingPointsBarItem from '../KeySellingPointsBarItem';
const DesignServicesItem = t0 => {
  const $ = _c(12);
  const {
    openMobileModal
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const {
    isMobileOrTablet
  } = useScreen();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DesignServicesIcon color="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMobileOrTablet || $[2] !== openMobileModal) {
    t2 = <KeySellingPointsBarItem icon={t1} onClick={() => {
      if (isMobileOrTablet) {
        openMobileModal({
          content: "Bring your dream space to life with help from our 3D room planner, expert tips and tricks, \n              and inspiring room designs - for free!",
          icon: <DesignServicesIcon color="white" />,
          cta: <CtaLink to="/free-design-services/" styling="solid-button" color="brand">Get started</CtaLink>
        });
      } else {
        setIsOpen(true);
      }
    }}>Free Design Services*</KeySellingPointsBarItem>;
    $[1] = isMobileOrTablet;
    $[2] = openMobileModal;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="KeySellingPointsBarItem-modal-icon"><DesignServicesIcon color="white" /></div>;
    t4 = () => {
      setIsOpen(false);
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mt-6"><CtaLink to="/free-design-services/" styling="solid-button" color="brand" onClick={() => setIsOpen(false)}>Get started</CtaLink></div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isOpen) {
    t6 = <StandardModal isOpen={isOpen} icon={t3} onClose={t4} title="Free Design Services">Bring your dream space to life with help from our 3D room planner, expert tips and tricks, and inspiring room designs - for free!{t5}</StandardModal>;
    $[7] = isOpen;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t6) {
    t7 = <>{t2}{t6}</>;
    $[9] = t2;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
DesignServicesItem.propTypes = {
  openMobileModal: PropTypes.func
};
export default DesignServicesItem;